import {AxiosError} from 'axios';
import {POST_CREATE_COORDINATOR_PROFILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateCoordinatorProfile = ({onError, onSuccess}: Input = {}) => {
  const postCreateCoordinatorProfile = async (reqBody: any) => {
    const res = await axiosClient.post<void>(POST_CREATE_COORDINATOR_PROFILE_URL, reqBody);

    return res.data;
  };

  return useCustomMutation(postCreateCoordinatorProfile, {
    onSuccess,
    onError,
  });
};
